import type React from "react";
import { AccordionTrigger } from "../ui/accordion";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import { CircularProgress } from "./CircularScore";

interface AccordionTitleWithTriggerProps {
	title: string;
	icon: React.ReactNode;
}

export const AccordionTitleWithTrigger: React.FC<
	AccordionTitleWithTriggerProps
> = (props) => {
	const { title, icon } = props;

	return (
		<AccordionTrigger className="px-3">
			<div className="flex items-center gap-2">
				{icon}
				<h2 className="text-lg font-semibold">{title}</h2>
			</div>
		</AccordionTrigger>
	);
};

interface AccordionTitleScoreWithTriggerProps {
	title: string;
	score: number;
}

export const AccordionTitleScoreWithTrigger: React.FC<
	AccordionTitleScoreWithTriggerProps
> = (props) => {
	const { title, score } = props;

	return (
		<AccordionTrigger className="px-3">
			<div className=" flex items-center gap-2">
				<ShieldCheckIcon className="size-4" />
				<h2 className="accordion-content-hidden text-lg font-semibold">
					{title}
				</h2>
				<div className="accordion-content-hidden w-7 h-7 ">
					<CircularProgress textHidden value={score} />
				</div>
				<h2 className="accordion-content-hidden text-lg font-semibold">
					{Math.round(score * 100)}%
				</h2>
			</div>
		</AccordionTrigger>
	);
};
